import { APIHandlerContext } from "GlobalContextProviders";
import { AxiosError } from "axios";
import { consoleLog } from "functions/v1/main/utilitiesFunctions";
import { useState, useEffect, useContext } from "react";

// This API component comes from here: https://betterprogramming.pub/learn-to-create-your-own-usefetch-react-hook-9cc31b038e53
const useB2GApiGet = (path : string, failCallBack?: (error: AxiosError) => void) => {
  const [data, setData] = useState<any>(null)
  const [error, setError] = useState<null | string>(null);
  const [loading, setLoading] = useState(true);
  const b2gAPI = useContext(APIHandlerContext);

  const getData = (milisecondDelay = 0) => {
    // Reset loading state and data
    setLoading(true);
    setData(null);
    // Make api call
    b2gAPI.get(path, 
      function(response){
        // Successfully got the data
        consoleLog(response.data); // For testing
        setTimeout(function() { // Built in optional delay
          setData(response.data);
          setLoading(false);
        }, milisecondDelay);
    }, failCallBack
	);
  }
  
  useEffect(() => {
    getData();
  }, [b2gAPI]); // Only run when the b2gAPI updates
  
  return { data, error, loading, setData, setLoading, setError, refetch : getData };
};
export default useB2GApiGet;